
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosError } from "axios";
import { ServerInterface, ServerRepositoryInterface } from "@/services/Server/Interfaces";

@Component({
  inject: ['serverRepository'],
})
export default class BackupRepoPicker extends Vue {
  private serverRepository!: ServerRepositoryInterface;

  public serverSearchLoading = false;

  public originServers: ServerInterface[] = [];

  public originServersFiltered: ServerInterface[] = [];

  @Prop({ default: '', required: true, type: String }) public value!: string;

  private _serverSearch = '';

  public get serverSearch(): string {
    return this._serverSearch;
  }

  public set serverSearch(val: string) {
    this._serverSearch = val;

    this.fetchOriginServers(val);
  }

  get originServerId(): string {
    return this.value;
  }

  set originServerId(value: string) {
    if (value !== this.value) {
      this.$emit('input', value);
    }
  }

  public async fetchOriginServers(query: string): Promise<void> {
    try {
      this.serverSearchLoading = true;
      if (!this.originServers.length) {
        this.originServers = await this.serverRepository.getServersOfType("OriginServer");
      }

      this.originServersFiltered = this.originServers
        .filter(y => y.hostname.toLowerCase().match(new RegExp(`^.*${query?.toLowerCase()}.*$`)));

    } catch (err) {
      this.onError(err);
    } finally {
      this.serverSearchLoading = false;
    }
  }

  private onError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}

